export default __webpack_public_path__ + "static/media/Cross-white.730a5b74.svg";